import React from 'react'
import logo from '../../Assets/plexusLoader3.gif'

const PumpingPlexLoader = () => {
    return <img src={logo} className="pumpingLoader"></img>
}

export default PumpingPlexLoader
